import { DateTime } from "luxon";

// Due to the fact that beginDatumTijd and eindDatumTijd in zod-schema can be either a DateTime or a string (according to the original KlusModel).
// In the places where this function is currently used, the following message appeared:
// Conversion of type 'DateTime<true> | DateTime<false>' to type 'string' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
// Type 'DateTime<false>' is not comparable to type 'string'.ts(2352)
export function toStringDate(input: DateTime | string): string {
  if (typeof input === "string") {
    return input;
  } else if (DateTime.isDateTime(input)) {
    if (!input.isValid) {
      throw new Error("DateTime is invalid");
    }
    return input.toISO()!;
  } else {
    throw new Error("Type of input is invalid");
  }
}
